import React from 'react';

const Members = () => {
  return (
    <div className="text-center p-8">
      <h1 className="text-4xl font-bold">Our Members</h1>
      <ul className="mt-6 space-y-4">
        <li className="text-xl">Member 1: Role</li>
        <li className="text-xl">Member 2: Role</li>
        <li className="text-xl">Member 3: Role</li>
      </ul>
    </div>
  );
};

export default Members;
